import React from "react";
import Gallery from "react-grid-gallery";
import store from "../../../../reduxstore";
import { EditGoujianImageDialogButton, DeleteDialogButton } from "../../utils";
import { makeStyles } from "@material-ui/styles";
const useStyles = makeStyles((theme) => ({
  warningText: {
    color: theme.palette.secondary.light,
  },
}));

function ImageGallery(props) {
  const classes = useStyles();

  const { images, freshData } = props;
  const { account } = store.getState();
  //鼠标hover时显示的内容样式
  const captionStyle = {
    backgroundColor: "rgba(0, 0, 0, 0.8)",
    maxHeight: "120px",
    overflow: "hidden",
    position: "absolute",
    top: "0px",
    width: "100%",
    height: "100%",
    color: "white",
    fontSize: "90%",
  };

  //鼠标hover时斜体用户名称样式
  const userCaptionStyle = {
    color: "red",
    fontSize: "70%",
    textAlign: "right",
    marginRight: "1em",
  };

  //缩略图标签样式
  const tagStyle = {
    display: "inline-flex",
    alignItems: "center",
    postion: "absolute",
    maxWidth: "100%",
    fontSize: "75%",
    fontWeight: "600",
    lineHeight: "1",
    color: "black",
    textAlign: "center",
  };

  const galleryImages = images.map((imageNow) => {
    const {
      id,
      thumbnail,
      image,
      description,
      architecture,
      user_nickname,
      user,
    } = imageNow;
    const customOverlay = (
      <div style={captionStyle}>
        <p
          style={{
            margin: "8px",
          }}
        >{`${description}(${architecture})`}</p>
        <p style={userCaptionStyle}>{`上传：${user_nickname}`}</p>
      </div>
    );
    // const tags = [{ value: description, title: description }];
    const thumbnailCaption = (
      <>
        <span style={tagStyle}>
          {description.length < 8
            ? description
            : `${description.substring(0, 8)}...`}
          {account.id === user || account.role === "教师" ? (
            <>
              <EditGoujianImageDialogButton
                style={tagStyle}
                freshData={(data) => {
                  freshData(data, "update");
                }}
                buttonText="编辑图片"
                initFormValue={imageNow}
              />
              <DeleteDialogButton
                buttonText="删除图片"
                freshData={() => {
                  freshData(null, "delete", id);
                }}
                deleteUrl={`/api/goujianimages/${id}/`}
                warningText={
                  <>
                    确定删除
                    {<span className={classes.warningText}>{description}</span>}
                    ,删除后将不可恢复
                  </>
                }
              />
            </>
          ) : null}
        </span>
      </>
    );

    return {
      src: image,
      thumbnail: thumbnail,
      thumbnailWidth: 256,
      thumbnailHeight: 256,
      // tags,
      caption: `${description}(${architecture})`,
      customOverlay,
      thumbnailCaption,
    };
  });

  return (
    <Gallery
      images={galleryImages}
      enableImageSelection={false}
      margin={4}
      imageCountSeparator={"/"}
      showLightboxThumbnails={true}
      rowHeight={256}
      backdropClosesModal
      lightboxWidth={1920}
      onClickImage={(e) => {
        window.open(e.target.src);
      }}
    />
  );
}

export default ImageGallery;
